import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { Slide } from "react-awesome-reveal";
import { Button } from "../../common/Button";
import { MiddleBlockSection, Content, ContentWrapper } from "./styles";
import { primaryHeaderColor } from "../../styles";
import Box from "@mui/material/Box";

interface MiddleBlockProps {
  title: string;
  content: string;
  button: string;
  t: any;
  id: string;
  custom?: any;
  img?: string;
}

const MiddleBlock = ({
  title,
  content,
  button,
  t,
  id,
  custom = "",
  img = "",
}: MiddleBlockProps) => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    element.scrollIntoView({
      behavior: "smooth",
    });
  };
  return (
    <MiddleBlockSection>
      {/* <Slide direction="up"> */}
      <Row justify="center" align="middle">
        <ContentWrapper>
          {!custom ? (
            <Col lg={24} md={24} sm={24} xs={24}>
              <h6
                style={{
                  fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                  fontWeight: "bold",
                  color: primaryHeaderColor,
                }}
                id={id}
              >
                {t(title)}
              </h6>
              {img && (
                <Box
                  component="img"
                  sx={{
                    display: "block",
                    overflow: "hidden",
                    marginRight: "auto",
                    marginLeft: "auto",
                    borderRadius: "100%",
                  }}
                  src={img}
                  alt="Heart of Life Floral Founders"
                />
              )}
              <Content>{t(content)}</Content>
              {button && (
                <Button name="submit" onClick={() => scrollTo("mission")}>
                  {t(button)}
                </Button>
              )}
            </Col>
          ) : (
            custom
          )}
        </ContentWrapper>
      </Row>
      {/* </Slide> */}
    </MiddleBlockSection>
  );
};

export default withTranslation()(MiddleBlock);
